import { encodeSalonpagePathId } from "@/lib/_url";
import {
  SALONPAGE_MAP_TILE_ATTRIBUTION,
  SALONPAGE_MAP_TILE_ESRI_HREF,
} from "./_map-tiles";
import { NoroshiReserveHost } from "./_noroshi-reserve-host";

type FooterNavKey = "top" | "menus" | "styles" | "staff";

interface SalonpageFooterProps {
  salon: {
    id: string | number;
    name?: string | null;
  };
  current?: FooterNavKey;
}

export function SalonpageFooter({ salon, current }: SalonpageFooterProps) {
  const salonId = encodeSalonpagePathId(salon.id);
  const links: { key: FooterNavKey; label: string; href: string }[] = [
    { key: "top", label: "サロントップ", href: `/salons/${salonId}` },
    { key: "menus", label: "メニュー", href: `/salons/${salonId}/menus` },
    { key: "styles", label: "スタイル", href: `/salons/${salonId}/styles` },
    { key: "staff", label: "スタッフ", href: `/salons/${salonId}/staffs` },
  ];

  return (
    <footer className="px-4 pb-8 pt-5 text-zinc-500">
      <NoroshiReserveHost salonId={String(salon.id)} />
      <nav className="mx-auto grid max-w-[25rem] grid-cols-4 rounded-full bg-white p-1 shadow-[0_2px_12px_rgba(15,23,42,0.08)]" aria-label="サロンページ">
        {links.map((link) => {
          const active = link.key === current;

          return (
            <a
              key={link.key}
              href={link.href}
              className={[
                "flex h-9 items-center justify-center rounded-full px-2 text-[11px] font-bold transition sm:text-xs",
                active
                  ? "bg-zinc-950 text-white shadow-sm"
                  : "text-zinc-500 hover:bg-zinc-100 hover:text-zinc-900",
              ].join(" ")}
              aria-current={active ? "page" : undefined}
            >
              {link.label}
            </a>
          );
        })}
      </nav>
      <SalonpageFooterInfo className="mt-7" />
    </footer>
  );
}

export function SalonpageFooterInfo({ className = "" }: { className?: string }) {
  return (
    <div className={["text-center", className].filter(Boolean).join(" ")}>
      <p className="text-xl font-black tracking-tight text-zinc-300">Hairbook</p>
      <p className="mt-4 text-xs font-medium text-zinc-400">Copyright © Cajon Inc.</p>
      <p className="mt-3 text-xs font-medium leading-6 text-zinc-400">
        <a href="https://hairbook.i-b-c.jp/" className="transition hover:text-zinc-700">Hairbookについて</a>
        <span className="px-2">/</span>
        <a href="/terms" className="transition hover:text-zinc-700">利用規約</a>
        <span className="px-2">/</span>
        <a href="/privacy" className="transition hover:text-zinc-700">プライバシーポリシー</a>
      </p>
      <SalonpageMapTileCredit />
    </div>
  );
}

function SalonpageMapTileCredit() {
  const [beforeEsri, afterEsri] = SALONPAGE_MAP_TILE_ATTRIBUTION.split("Esri");

  return (
    <p className="mt-5 text-[10px] font-medium leading-5 text-zinc-400">
      {beforeEsri}
      <a href={SALONPAGE_MAP_TILE_ESRI_HREF} className="transition hover:text-zinc-700">
        Esri
      </a>
      {afterEsri}
    </p>
  );
}
